export const checkRichTextIsNotEmpty = (inputString: string): boolean => {
    const isEmpty = /^<p><br><\/p>$/.test(inputString);
    return !isEmpty;
};
